import { Image } from 'native-base';
import React, { ReactNode } from 'react';

import useWindow from 'app/hooks/useWindow';
import { cdn } from 'app/utils/image';

export type BackgroundProps = {
  children?: ReactNode;
  image?: Maybe<{
    url: string;
    width: Maybe<number>;
    height: Maybe<number>;
  }>;
};

export default function Background({ image }: BackgroundProps) {
  const { width, height } = useWindow();

  return (
    <Image
      _android={{
        zIndex: 0,
      }}
      alt="Background"
      bg="gray.600"
      blurRadius={1}
      bottom="0"
      height={height}
      left="0"
      position="absolute"
      right="0"
      source={{
        uri: cdn(image?.url ?? '', [['resize', { width }]]),
      }}
      top="0"
      width={width}
      zIndex="1"
    />
  );
}
